import React, { Fragment, useContext, useState } from "react";
import { ShareContext } from "components/context/share/ShareContext";
import ContentPageShareLink from "./ContentPageShareLink";
import { ContentPageShareAdditionalLinksMobile } from "./ContentPageShareAdditionalLinksMobile";

export const ContentPageShareAdditionalLinks = () => {
	const [additionalMobileFlag, setAddiontalMobileFlag] = useState(false);
	const data = useContext(ShareContext);
	const {
		additionalLinks,
		publicLinks,
		isMobile,
		copyLabel,
		copyConfirm,
		updateState,
		selectedTab,
		analytics
	} = data;
	const { label, links } = additionalLinks;

	const additionalMobileToggle = () => {
		setAddiontalMobileFlag(!additionalMobileFlag);
		updateState({ selectedTab: label });
	};
	const goBackToPublicLInks = () => {
		setAddiontalMobileFlag(!additionalMobileFlag);
		updateState({ selectedTab: publicLinks.label || label });
	};

	return (
		<Fragment>
			{!isMobile && selectedTab === label && (
				<div className="content-page-share-additional-links">
					{links && (
						<Fragment>
							{links.map((link, index) => {
								return (
									<ContentPageShareLink
										className="content-page-share-additional-links-url"
										shareLabel={link.shareLabel}
										shareUrl={link.shareUrl}
										copyLabel={copyLabel}
										key={index}
										copyConfirm={copyConfirm}
										analytics={analytics}
									/>
								);
							})}
						</Fragment>
					)}
				</div>
			)}
			{links && isMobile && (
				<Fragment>
					{publicLinks && (
						<button
							className="content-page-share-additional-links-mobile-button"
							aria-label={label}
							onClick={() => additionalMobileToggle()}
						>
							{label}
						</button>
					)}
					{
						<ContentPageShareAdditionalLinksMobile
							onClick={() => goBackToPublicLInks()}
							additionalMobileFlag={additionalMobileFlag}
						/>
					}
				</Fragment>
			)}
		</Fragment>
	);
};

export default {
	ContentPageShareAdditionalLinks
};
